export const HOME = {
  emergentLink: "emergent-link",
};

export const AUTH = {
  loginTab: "login-tab",
  registerTab: "register-tab",
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  errorMsg: "auth-error-msg",
  logoutBtn: "logout-btn",
};

export const NAV = {
  logo: "nav-logo",
  dashboard: "nav-dashboard",
  gallery: "nav-gallery",
  favorites: "nav-favorites",
  albums: "nav-albums",
  uploadBtn: "nav-upload-btn",
  userMenu: "nav-user-menu",
};

export const PET = {
  addBtn: "pet-add-btn",
  nameInput: "pet-name-input",
  speciesSelect: "pet-species-select",
  breedInput: "pet-breed-input",
  birthdayInput: "pet-birthday-input",
  notesInput: "pet-notes-input",
  saveBtn: "pet-save-btn",
  deleteBtn: "pet-delete-btn",
  card: "pet-card",
  setCoverBtn: "pet-set-cover-btn",
};

export const PHOTO = {
  uploadInput: "photo-upload-input",
  uploadSubmit: "photo-upload-submit",
  captionInput: "photo-caption-input",
  petSelect: "photo-pet-select",
  albumInput: "photo-album-input",
  card: "photo-card",
  favoriteBtn: "photo-favorite-btn",
  deleteBtn: "photo-delete-btn",
  detailOpen: "photo-detail-open",
  reanalyzeBtn: "photo-reanalyze-btn",
  selectToggle: "photo-select-toggle",
  bulkFav: "bulk-favorite-btn",
  bulkDel: "bulk-delete-btn",
  bulkAlbum: "bulk-album-btn",
  tagInput: "photo-tag-input",
  tagAddBtn: "photo-tag-add-btn",
};

export const SHARE = {
  toggleBtn: "share-toggle-btn",
  copyBtn: "share-copy-btn",
  linkInput: "share-link-input",
  publicHero: "public-share-hero",
};

export const BIRTHDAY = {
  strip: "birthday-strip",
  card: "birthday-card",
};
